import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Signup from "../pages/SignUp";
import Login from "../pages/Login";
import Resetpassword from "../pages/ResetPassword";
// import Rewards from "../pages/accounts/rewards/Rewards";
import GetApp from "../pages/GetApp";
import Plaid from "../pages/Plaid";
import ManageAccounts from "../pages/ManageAccounts";
import Protected from "../components/Protected";
import UserForm from "../pages/UserForm";
import Withdrawal from "../pages/Withdrawal";
import SignupV2 from "../pages/SignupV2";
import WillowSignup from "../pages/WillowSignup";
import WillowSignupSuccess from "../pages/WillowSignupSuccess";
import { REMITTANCE_SIGNUP } from "../config/constants";
import VerifyOtp from "../pages/toi/VerifyOtp";
import { REMITTANCE_HOME_PATH, REMITTANCE_NB_HOME_PATH } from "../constants";
import Reauthenticate from "../pages/Remittance/Reauthenticate";
import RemittanceDashboard from "../pages/Remittance/RemittanceDashboard";
import RemittanceRateHome from "../pages/Remittance/RemittanceRateHome";
import VerifyDetails from "../pages/VerifyDetails";



import RemittanceCalcuator from "../pages/Remittance/RemittanceCalculator";
import CricbuzzSignup from "../pages/cricbuzz/CricbuzzSignup";

function RouteController() {
  return (
    <Router basename="/getapp">
      <Routes>
        <Route index element={<Login />} />
        {/* <Route path="/" element={<Navigate to="/login" />} /> */}
        <Route path="/signup" element={<Signup />} />
        <Route path="/signup/v2" element={<SignupV2 />} />
        <Route path="/login" element={<Login />} />
        <Route path="/resetPassword" element={<Resetpassword />} />
        <Route path="/user-form" element={<UserForm />} />
        <Route path="/withdrawal" element={<Withdrawal />} />
        <Route
          path="/plaid"
          element={
            <Protected>
              <Plaid />
            </Protected>
          }
        />
        <Route
          path="/getApp"
          element={
            <Protected>
              <GetApp />
            </Protected>
          }
        />
        <Route path="/verifyDetails" element={<VerifyDetails />} />
        <Route
          path="/accounts"
          element={
            <Protected>
              <ManageAccounts />
            </Protected>
          }
        />
        <Route
          path="/remittance/calculator"
          element={<RemittanceCalcuator />}
        />
        {/* <Route
          path="/rewards"
          element={
            <Protected>
              <Rewards />
            </Protected>
          }
        ></Route> */}
       <Route path="/willow/forget-password" element={<WillowSignup />} />
        <Route path="/willow/success" element={<WillowSignupSuccess />} />
        <Route path="/cricbuzz" element={<CricbuzzSignup />} />
        <Route
          path="/remittance/signup"
          element={<SignupV2 screenType={REMITTANCE_SIGNUP} />}
        />

        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route
          path="/remittance/bankadd"
          element={
            <Protected>
              <Plaid />
            </Protected>
          }
        />
        <Route
          path="/re-authenticate"
          element={
            <Protected>
              <Reauthenticate />
            </Protected>
          }
        />
        <Route
          path={REMITTANCE_NB_HOME_PATH}
          element={
            <Protected>
              <RemittanceDashboard />
            </Protected>
          }
        />
        <Route path={REMITTANCE_HOME_PATH} element={<RemittanceRateHome />} />
      </Routes>
    </Router>
  );
}

export default RouteController;
